import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_language_hdr_RowClass} from '../../../dbschema';

export class WebsiteLanguageContainerModel extends BaseContainerModel {
  bl_cms_website_language_hdr: bl_cms_website_language_hdr_RowClass = new bl_cms_website_language_hdr_RowClass();
}
